import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { AudioManager } from "../AudioManager";
import { GameModel } from "../GameModel";
import { SponsorManager, WhyCallAd } from "../SponsorManager";
import { Board } from "./cards/Board";
import { Boot } from "./Boot";

export class GUI extends Phaser.Group {

    public developmentMenuButton: Phaser.Button;
    
    private gameLogo: Phaser.Image;
    private soundOnButton: Phaser.Button;
    private soundOffButton: Phaser.Button;
    private resignButton: Phaser.Button;
    private reshuffleButton: Phaser.Button;
    private helpButton: Phaser.Button;
    private saveButton: Phaser.Button;
    private undoButton: Phaser.Button;
    private retrieveButton: Phaser.Button;
    private hintsButton: Phaser.Button;
    private lowerInterface: Phaser.Image;
    private fullScreenButton: Phaser.Image;
    
    constructor(game: Phaser.Game) {

        super(game, null, "gui");
        
        this.gameLogo = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, 5, "game-logo", null);
        this.gameLogo.scale.setTo(GameVars.scaleX * .92, .92);
        this.gameLogo.anchor.x = .5;
        this.add(this.gameLogo);
        
        this.lowerInterface = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT, "texture_atlas_1", "lower-interface.png");
        this.lowerInterface.anchor.setTo(.5, 1);
        this.lowerInterface.scale.x = GameVars.scaleX;
        this.add(this.lowerInterface);
        
        this.soundOnButton = new Phaser.Button(this.game, 75, 30, "texture_atlas_1", this.onClickSoundOnButton, this);
        this.soundOnButton.setFrames("button-sound-on-on.png", "button-sound-on-off.png", "button-sound-on-on.png");
        this.soundOnButton.anchor.setTo(.5, .5);
        this.soundOnButton.scale.x = GameVars.scaleX;
        this.soundOnButton.visible = !AudioManager.getInstance().isAudioMuted;
        this.soundOnButton.forceOut = true;
        this.add(this.soundOnButton);
        
        this.soundOffButton = new Phaser.Button(this.game, 75, 30, "texture_atlas_1", this.onClickSoundOffButton, this);
        this.soundOffButton.setFrames("button-sound-off-on.png", "button-sound-off-off.png", "button-sound-off-on.png");
        this.soundOffButton.anchor.setTo(.5, .5);
        this.soundOffButton.scale.x = GameVars.scaleX;
        this.soundOffButton.visible = AudioManager.getInstance().isAudioMuted;
        this.soundOnButton.forceOut = true;
        this.add(this.soundOffButton);
        
        this.resignButton = new Phaser.Button(this.game, 885, 30, "texture_atlas_1", this.onClickResign, this);
        this.resignButton.setFrames("button-resign-on.png", "button-resign-off.png", "button-resign-on.png");
        this.resignButton.anchor.setTo(.5, .5);
        this.resignButton.scale.x = GameVars.scaleX;
        this.resignButton.forceOut = true;
        this.add(this.resignButton);
        
        this.helpButton = new Phaser.Button(this.game, 75, 75, "texture_atlas_1", this.onClickHelp, this);
        this.helpButton.setFrames("button-help-on.png", "button-help-off.png", "button-help-on.png");
        this.helpButton.anchor.setTo(.5, .5);
        this.helpButton.scale.x = GameVars.scaleX;
        this.helpButton.forceOut = true;
        this.add(this.helpButton);
        
        const reshuffleOffTextureName =  "button-reshuffle-" + GameVars.getInstance().reshuffles.toString() + "-off.png";
        const reshuffleOnTextureName = "button-reshuffle-" + GameVars.getInstance().reshuffles.toString() + "-on.png";
        
        this.reshuffleButton = new Phaser.Button(this.game, GameConstants.GAME_WIDTH / 2 +  200 * GameVars.scaleX , 612, "texture_atlas_1", this.onClickReshuffle, this);
        this.reshuffleButton.setFrames(reshuffleOnTextureName, reshuffleOffTextureName, reshuffleOnTextureName);
        this.reshuffleButton.anchor.setTo(.5, .5);
        this.reshuffleButton.scale.x = GameVars.scaleX;
        this.reshuffleButton.forceOut = true;
        this.add(this.reshuffleButton);

        this.saveButton = new Phaser.Button(this.game, 885, 75, "texture_atlas_1", this.onClickSave, this);
        this.saveButton.setFrames("button-save-on.png", "button-save-off.png", "button-save-on.png");
        this.saveButton.anchor.setTo(.5, .5);
        this.saveButton.scale.x = GameVars.scaleX;
        this.saveButton.forceOut = true;
        this.add(this.saveButton);

        this.retrieveButton = new Phaser.Button(this.game, 885, 75, "texture_atlas_1", this.onClickRetrieve, this);
        this.retrieveButton.setFrames("button-retrieve-on.png", "button-retrieve-off.png", "button-retrieve-on.png");
        this.retrieveButton.anchor.setTo(.5, .5);
        this.retrieveButton.scale.x = GameVars.scaleX;
        this.retrieveButton.forceOut = true;
        this.add(this.retrieveButton);
            
        if (GameVars.getInstance().savedGameStateData && !GameVars.getInstance().retrieveSavedGame) {
            this.saveButton.visible = false; 
        } else {
            this.retrieveButton.visible = false;
        }
        
        this.undoButton = new Phaser.Button(this.game, GameConstants.GAME_WIDTH / 2 -  305 * GameVars.scaleX, 608, "texture_atlas_1", this.onClickUndo, this);
        this.undoButton.setFrames("button-undo-on.png", "button-undo-off.png", "button-undo-on.png");
        this.undoButton.anchor.setTo(.5, .5);
        this.undoButton.scale.x = GameVars.scaleX;
        this.undoButton.forceOut = true;
        this.deactivateUndoButton();
        this.add(this.undoButton);
        
        var hintOffTextureName: string =  "button-hint-" + GameVars.getInstance().hints.toString() + "-off.png";
        var hintOnTextureName: string = "button-hint-" + GameVars.getInstance().hints.toString() + "-on.png";
            
        this.hintsButton = new Phaser.Button(this.game, GameConstants.GAME_WIDTH / 2 -  200 * GameVars.scaleX , 612, "texture_atlas_1", this.onClickHints, this);
        this.hintsButton.setFrames(hintOnTextureName, hintOffTextureName, hintOnTextureName);
        this.hintsButton.anchor.setTo(.5, .5);
        this.hintsButton.scale.x = GameVars.scaleX;
        this.hintsButton.forceOut = true;
        this.add(this.hintsButton);
        
        if (GameConstants.DEVELOPMENT) {
            
            this.developmentMenuButton = new Phaser.Button(this.game, GameConstants.GAME_WIDTH / 2, 300, "texture_atlas_0", this.onClickDevelopment, this);
            this.developmentMenuButton.setFrames("development-button-on.png", "development-button-off.png", "development-button-on.png");
            this.developmentMenuButton.scale.x = GameVars.scaleX;
            this.developmentMenuButton.anchor.setTo(.5, .5);
            this.developmentMenuButton.forceOut = true;
            this.add(this.developmentMenuButton);
        }
    
        this.fullScreenButton = null;
 
        if (GameConstants.SPONSOR === GameConstants.MINIJUEGOS) {
            
            const sponsorLogo = new Phaser.Image(this.game, 885, 135, "sponsor-logo", null);
            sponsorLogo.anchor.setTo(.5, .5);
            sponsorLogo.scale.x = GameVars.scaleX;
            sponsorLogo.inputEnabled = true;
            sponsorLogo.events.onInputDown.add(this.onLogoClicked, this);
            sponsorLogo.alpha = 0;
            this.add(sponsorLogo);
            
            this.game.add.tween(sponsorLogo)
                .to({alpha: 1 }, 500 , Phaser.Easing.Cubic.Out, true, 2250);
        }
    }
    
    public resizeFullScreen(): void {
        
        this.gameLogo.scale.setTo(GameVars.scaleX * .92, .92);
        
        this.lowerInterface.scale.x = GameVars.scaleX;   
        this.resignButton.scale.x = GameVars.scaleX;
        this.reshuffleButton.scale.x = GameVars.scaleX;
        this.helpButton.scale.x = GameVars.scaleX;
        this.saveButton.scale.x = GameVars.scaleX;
        this.retrieveButton.scale.x = GameVars.scaleX;
        this.hintsButton.scale.x = GameVars.scaleX;
        this.soundOnButton.scale.x = GameVars.scaleX;            
        this.soundOffButton.scale.x = GameVars.scaleX;
        
        if (this.fullScreenButton) {
            
            this.fullScreenButton.scale.x = GameVars.scaleX;
            
            if (this.game.scale.isFullScreen) {
                this.fullScreenButton.visible = false;
            } else {
                this.fullScreenButton.visible = true;
            }
        }

        this.hintsButton.x = GameConstants.GAME_WIDTH / 2 -  200 * GameVars.scaleX;
        this.reshuffleButton.x = GameConstants.GAME_WIDTH / 2 +  200 * GameVars.scaleX;  
    }
    
    public pause(): void {
        
        this.resignButton.inputEnabled = false;
        this.reshuffleButton.inputEnabled = false;
        this.helpButton.inputEnabled = false;
        this.saveButton.inputEnabled = false;
        this.retrieveButton.inputEnabled = false;
        this.hintsButton.inputEnabled = false;

        if (this.developmentMenuButton) {
            this.developmentMenuButton.visible = false;
        }
        
        if (GameVars.getInstance().originPileData !== null) {
            this.undoButton.inputEnabled = false;
        }
    }
    
    public resume(): void {
        
        this.resignButton.inputEnabled = true;
        this.reshuffleButton.inputEnabled = true;
        this.helpButton.inputEnabled = true;
        this.saveButton.inputEnabled = true;
        this.retrieveButton.inputEnabled = true;
        this.hintsButton.inputEnabled = true;

        if (this.developmentMenuButton) {
            this.developmentMenuButton.visible = true;
        }
        
        if (GameVars.getInstance().originPileData !== null) {
            this.undoButton.inputEnabled = true;
        }
    }
    
    public undo(): void {
        
        this.deactivateUndoButton();
    }
    
    public activateUndoButton(): void {
        
        this.undoButton.alpha = 1;
        this.undoButton.inputEnabled = true;
    }
    
    public deactivateUndoButton(): void {
        
        this.undoButton.alpha = .5;
        this.undoButton.inputEnabled = false;
    }
    
    private onClickSoundOnButton(): void {
    
        this.soundOnButton.visible = false;
        this.soundOffButton.visible = true;
        
        AudioManager.getInstance().isAudioMuted = true;
    }
    
    private onClickSoundOffButton(): void {
        
        this.soundOnButton.visible = true;
        this.soundOffButton.visible = false;
        
        AudioManager.getInstance().isAudioMuted = false;
    }
    
    private onClickResign(): void {

        if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {
            if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                gdsdk.showAd();
                GameVars.typeAd = "Resign";
            } else {
                GameModel.currentInstance.onClickResign();
            }
        } else {
            GameModel.currentInstance.onClickResign();
        }
        
        
        
        AudioManager.getInstance().playSound("click");
    }
    
    private onClickHelp(): void {

        GameModel.currentInstance.onClickHelp();
        
        AudioManager.getInstance().playSound("click");
    }
    
    private onClickReshuffle(): void {

        if (GameVars.getInstance().reshuffles === 0 || GameVars.getInstance().shuffling) {
            return;
        }

        if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {
            if (gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                gdsdk.showAd("rewarded");
                GameVars.typeAd = "Reshuffle";
            } else {
                GameModel.currentInstance.onReshuffle();
            }
        } else {
            GameModel.currentInstance.onReshuffle();
        }
        
        switch (GameVars.getInstance().reshuffles) {
                    
            case 0:
                this.reshuffleButton.setFrames("button-reshuffle-0-on.png", "button-reshuffle-0-off.png", "button-reshuffle-0-on.png");
                break;
                
            case 1:
                this.reshuffleButton.setFrames("button-reshuffle-1-on.png", "button-reshuffle-1-off.png", "button-reshuffle-1-on.png");
                break;
                
            case 2:
                this.reshuffleButton.setFrames("button-reshuffle-2-on.png", "button-reshuffle-2-off.png", "button-reshuffle-2-on.png");
                break;
                
            default:
                break;
        }
        
        AudioManager.getInstance().playSound("click");
    }
    
    private onClickHints(): void {

        if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {

            if (Board.currentInstance.highlightSprite) {
                return;
            }

            if (GameVars.getInstance().hints === 0) {
                return;
            }

            if (gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                gdsdk.showAd("rewarded");
                GameVars.typeAd = "Hint";
            } else {
                GameModel.currentInstance.onHint();
            }

            switch (GameVars.getInstance().hints) {
                            
                case 0:
                    this.hintsButton.setFrames("button-hint-0-on.png", "button-hint-0-off.png", "button-hint-0-on.png");
                    break;
                    
                case 1:
                    this.hintsButton.setFrames("button-hint-1-on.png", "button-hint-1-off.png", "button-hint-1-on.png");
                    break;
                    
                case 2:
                    this.hintsButton.setFrames("button-hint-2-on.png", "button-hint-2-off.png", "button-hint-2-on.png");
                    break;
                    
                default:
                    break;
            }
            
        } else {
            SponsorManager.adFilter(() => {
            
                if (Board.currentInstance.highlightSprite) {
                    return;
                }

                if (GameVars.getInstance().hints === 0) {
                    return;
                }
                    
                GameModel.currentInstance.onHint();
                
                switch (GameVars.getInstance().hints) {
                            
                    case 0:
                        this.hintsButton.setFrames("button-hint-0-on.png", "button-hint-0-off.png", "button-hint-0-on.png");
                        break;
                        
                    case 1:
                        this.hintsButton.setFrames("button-hint-1-on.png", "button-hint-1-off.png", "button-hint-1-on.png");
                        break;
                        
                    case 2:
                        this.hintsButton.setFrames("button-hint-2-on.png", "button-hint-2-off.png", "button-hint-2-on.png");
                        break;
                        
                    default:
                        break;
                }
    
            }, Boot.currentInstance.game, WhyCallAd.onShowHint);
        }
        
        AudioManager.getInstance().playSound("click");
    }
    
    private onClickSave(): void {
        
        this.saveButton.visible = false;
        this.retrieveButton.visible = true;
        
        GameModel.currentInstance.saveGameState();
    }
    
    private onClickUndo(): void {
        
        GameModel.currentInstance.undo();
    }
    
    private onClickRetrieve(): void {
        
        GameModel.currentInstance.retrieveGameState();
    }
    
    private onClickDevelopment(): void {
        
        this.developmentMenuButton.visible = false;
        GameModel.currentInstance.showDevelopmentLayer();
        
        AudioManager.getInstance().playSound("click");
    }
    
    private onLogoClicked(): void {
            
        var win: any = window.open(GameConstants.LINK_MINIJUEGOS, "_blank");
        
        win.focus();
    }
}
